import nocSocHelpdesk from "public/network-services/icons/noc-soc-helpdesk.png";
import { SimpleList } from "@/components/list";

const MONITORING_POINTS = [
  "Real-time monitoring of network health, uptime, and latency.",
  "Incident detection & root cause analysis to resolve network issues before they escalate.",
  "Automated patch & configuration management for security compliance.",
  "Load balancing & bandwidth management for optimal network performance.",
  "Comprehensive reporting & analytics for visibility into network trends.",
];

const CYBER_SECURITY_POINTS = [
  "AI-powered threat intelligence & SIEM monitoring for proactive risk mitigation.",
  "Intrusion detection & automated incident response to prevent cyber attacks.",
  "Zero Trust security framework for endpoint protection and authentication.",
  "Cloud & data security compliance to prevent breaches and ensure regulatory adherence.",
  "Security awareness & employee training to mitigate phishing and social engineering risks.",
];

const IT_POINTS = [
  "Multi-tier support for remote troubleshooting, ticket resolution, and user queries.",
  "24/7 technical support for both employees and customers.",
  "Software updates, patching, and system configuration assistance.",
  "Remote desktop support & IT asset management.",
  "Knowledge base & self-service portals for efficiency.",
];

const COMPLIANCE_POINTS = [
  "Ensures regulatory compliance with frameworks like ISO 27001, GDPR, HIPAA, SOC 2, and NIST.",
  "Risk assessments & security audits for proactive cyber defense.",
  "Incident response planning for disaster recovery & business continuity.",
];

export const SOLUTIONS_CONSTANTS = {
  title: "Features of NOC, SOC & Helpdesk Services",
  list: [
    {
      content: <SimpleList points={MONITORING_POINTS} />,
      image: nocSocHelpdesk,
      title: "24/7 Network Monitoring & Performance Optimization (NOC)",
    },
    {
      content: <SimpleList points={CYBER_SECURITY_POINTS} />,
      image: nocSocHelpdesk,
      title: "Advanced Cybersecurity & Threat Detection (SOC)",
    },
    {
      content: <SimpleList points={IT_POINTS} />,
      image: nocSocHelpdesk,
      title: "IT Helpdesk Support & End-User Assistance",
    },
    {
      content: <SimpleList points={COMPLIANCE_POINTS} />,
      image: nocSocHelpdesk,
      title: "Compliance & Risk Management",
    },
  ],
};
